const infodisplay = (state = [], action) => {
    switch (action.type) {
      case 'TOGGLE_DISPLAY':
      return {
          type: "TOGGLE_DISPLAY",
          infodisplay: action.infodisplay,
          ingdesk: action.ingdesk
        }
      default:
        return state
    }
  }
  
  export default infodisplay